import { useEffect, useState } from 'react';
import { ISelectOption } from '@widgets/multi-select';
import { useClientOptions } from '@app/queries/options/useClientOptions';
import { useRegionOptions } from '@app/queries/options/useRegionOptions';
import { useSourceOptions } from '@app/queries/options/useSourceOptions';
import { useTagOptions } from '@app/queries/options/useTagOptions';
import { useManagerOptions } from '@app/queries/options/useManagerOptions';
import { useHostingStatusOptions } from '@app/queries/options/useHostingStatusOptions';
import { useHostingLocationOptions } from '@app/queries/options/useHostingLocationOptions';

export interface IAccountCreateOptions {
  isLoading: boolean;
  statusesOptions: ISelectOption[];
  locationsOptions: ISelectOption[];
}

function useHostingCreateOptions(): IAccountCreateOptions {
  const statusesOptionsFetcher = useHostingStatusOptions();
  const locationsOptionsFetcher = useHostingLocationOptions();

  const [statusesOptions, setStatusesOptions] = useState<ISelectOption[]>([]);
  const [locationsOptions, setLocationsOptions] = useState<ISelectOption[]>([]);

  useEffect(() => {
    (async () => {
      const data = await statusesOptionsFetcher.fetch();
      setStatusesOptions(data);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const data = await locationsOptionsFetcher.fetch();
      setLocationsOptions(data);
    })();
  }, []);

  const isLoading = !(statusesOptionsFetcher.isSuccess && locationsOptionsFetcher.isSuccess);

  return {
    isLoading,
    statusesOptions: statusesOptionsFetcher.isSuccess ? statusesOptions : [],
    locationsOptions: locationsOptionsFetcher.isSuccess ? locationsOptions : [],
  };
}

export default useHostingCreateOptions;
